
import {translate} from '@elements/translations';
import {defineComponent, defineEmits} from 'vue';
import StepNav from "~vue/components/step-nav/StepNav.vue";


export default defineComponent({
    name: 'ModalHeader',
    props: {
        steps: {
            type: Number,
            required: true,
        },
        step: {
            type: Number,
            required: true,
        },
        stepViews: {
            type: Array,
            required: true,
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    components: {StepNav},
    emits: ['closeModal'],
    setup(props, {emit}) {

        const goBack = () => {

        };

        return {
            goBack,
            translate
        };
    }
});
